export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./sitepages-layout.vue?vue&type=template&id=2f0c4db3"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/sitepages-layout.vue?vue&type=template&id=2f0c4db3
// module id = ceHS
// module chunks = 0